import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PhxFloatingButtonDirective } from "./phx-floating-button.directive";
import { PhxFloatingButtonGroupComponent } from "./floating-button-group/phx-floating-button-group.component";

@NgModule({
  imports: [CommonModule],
  declarations: [PhxFloatingButtonDirective, PhxFloatingButtonGroupComponent],
  exports: [PhxFloatingButtonDirective, PhxFloatingButtonGroupComponent],
})
export class PhxFloatingButtonModule { }
